import Link from "next/link";
import { SVGProps } from "react";
import { FaSpotify } from "react-icons/fa";
import { LuFacebook, LuInstagram, LuLink } from "react-icons/lu";
import { PiAppleLogoFill, PiYoutubeLogoFill } from "react-icons/pi";
import { RxLinkedinLogo } from "react-icons/rx";

interface Props extends SVGProps<SVGSVGElement> {}

export const X = ({ ...props }: Props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            fill="black"
            viewBox="0 0 512 512"
        >
            <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
        </svg>
    );
};

interface SocialLinkProps extends Props {
    href: string;
}
export const SocialLink = ({ href, ...props }: SocialLinkProps) => {
    if (!href) return null;
    let icon;

    switch (href) {
        case href.match(/facebook/)?.input:
            icon = <LuFacebook {...props} />;
            break;

        case href.match(/twitter/)?.input ??
            href.match(/https:\/\/x.com/)?.input:
            icon = <X {...props} />;
            break;

        case href.match(/instagram/)?.input:
            icon = <LuInstagram {...props} />;
            break;

        case href.match(/linkedin/)?.input:
            icon = <RxLinkedinLogo {...props} />;
            break;

        case href.match(/youtube/)?.input:
            icon = <PiYoutubeLogoFill {...props} />;
            break;

        case href.match(/spotify/)?.input:
            icon = <FaSpotify {...props} />;
            break;

        case href.match(/apple/)?.input:
            icon = <PiAppleLogoFill {...props} />;
            break;

        default:
            icon = <LuLink {...props} />;
    }

    return (
        <Link href={href} className={props.className} target="_blank">
            {icon}
        </Link>
    );
};
